import { useField } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

import Dropzone from "./Dropzone";

type FileFieldProps = {
    className?: string;
    name: string;
    required?: boolean;
};

const FileField = ({ className, name, required }: FileFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField(name);

    return (
        <Form.Group
            className={`position-relative mb-5 ${className || ""}`}
            controlId={name}
        >
            <Dropzone
                value={field.value}
                onChange={helpers.setValue}
                fieldError={meta.error}
                setFieldError={helpers.setError}
                required={true}
            />
        </Form.Group>
    );
};

export default FileField;
